(() => {
  'use strict';
  const config = window.Aulbery || {};
  const select = (s, root = document) => root.querySelector(s);
  const all = (s, root = document) => Array.from(root.querySelectorAll(s));
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const money = value => new Intl.NumberFormat(config.locale || 'en-US', {style: 'currency', currency: config.currency || 'USD'}).format(Number(value || 0) / 100);
  const route = path => `${(config.root || '/').replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;
  const newImage = (handle, source) => {
    const entry=config.images?.[handle];
    if(!entry)return source;
    let filename='';
    try{filename=decodeURIComponent(new URL(source || '',location.href).pathname.split('/').pop());}catch{}
    const uploaded=Object.keys(entry.images).find(name=>name.startsWith('aulbery-')&&filename.startsWith(name.replace(/\.[^.]+$/,'')));
    return entry.images[filename] || entry.images[uploaded] || entry.default;
  };
  let currentCart;
  let previewState;
  const previewCart = () => {
    if (!previewState) {
      try { previewState = JSON.parse(sessionStorage.getItem('aulbery-preview-cart') || '[]'); } catch { previewState = []; }
      if (!Array.isArray(previewState)) previewState = [];
    }
    const stored = previewState;
    const items = stored.map(item => {
      const p = (config.previewCatalog || []).find(p => p.variants.some(v => String(v.id) === String(item.id)));
      if (!p) return null;
      const v = p.variants.find(v => String(v.id) === String(item.id));
      return {key:String(v.id),variant_id:v.id,quantity:item.quantity,product_title:p.title,variant_title:v.options.join(' / '),url:p.url,image:v.featured_image?.src || p.image,final_price:v.price,final_line_price:v.price*item.quantity,discounts:[]};
    }).filter(Boolean);
    return {items,item_count:items.reduce((n,i)=>n+i.quantity,0),total_price:items.reduce((n,i)=>n+i.final_line_price,0),currency:config.currency};
  };
  async function cartRequest(action, payload) {
    if (config.preview) {
      const cart = previewCart();
      const stored = cart.items.map(i=>({id:i.variant_id,quantity:i.quantity}));
      if (action === 'add') {
        const item = stored.find(i=>String(i.id)===String(payload.id));
        if (item) item.quantity += Number(payload.quantity || 1);
        else stored.push({id:payload.id,quantity:Number(payload.quantity || 1)});
      } else if (action === 'change') {
        const item = stored.find(i=>String(i.id)===String(payload.id));
        if (item) item.quantity=Number(payload.quantity);
      }
      previewState=stored.filter(i=>i.quantity>0);
      try { sessionStorage.setItem('aulbery-preview-cart',JSON.stringify(previewState)); } catch {}
      return previewCart();
    }
    const response = await fetch(route(action === 'get' ? 'cart.js' : `cart/${action}.js`), {
      method:action === 'get' ? 'GET' : 'POST',credentials:'same-origin',headers:{'Accept':'application/json',...(action === 'get' ? {} : {'Content-Type':'application/json'})},
      ...(action === 'get' ? {} : {body:JSON.stringify(payload)})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }
  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    all('dialog[open]').forEach(d => d.close());
    dialog.showModal();
    if (id === 'aulbery-cart') refreshCart().catch(showCartError);
  }
  function showCartError(error) {
    const node = select('[data-au-cart-error]');
    if (node) node.textContent = error.message || 'Your bag could not be updated. Please try again.';
  }
  function renderCart(cart) {
    currentCart = cart;
    all('[data-au-cart-count]').forEach(el => el.textContent = cart.item_count);
    all('[data-au-cart-total]').forEach(el => el.textContent = money(cart.total_price));
    const container = select('[data-au-cart-items]');
    if (!container) return;
    container.innerHTML = cart.items.length ? cart.items.map(item => `
      <div class="au-cart-item" data-au-line="${escapeHTML(item.key)}">
        ${item.image ? `<img src="${escapeHTML(newImage(item.handle || item.url?.split('/products/')[1]?.split('?')[0],item.image))}" alt="${escapeHTML(item.product_title)}" width="84" height="106">` : '<span></span>'}
        <div><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
          <p class="au-cart-variant">${item.variant_title && item.variant_title !== 'Default Title' ? escapeHTML(item.variant_title) : ''}</p>
          <div class="au-cart-item-bottom"><div class="au-qty"><button type="button" data-au-cart-qty="-1" aria-label="Decrease quantity">−</button><input type="number" min="0" value="${item.quantity}" data-au-cart-input aria-label="Quantity for ${escapeHTML(item.product_title)}"><button type="button" data-au-cart-qty="1" aria-label="Increase quantity">+</button></div><span class="au-cart-item-price">${money(item.final_line_price)}</span></div>
          <button class="au-remove" type="button" data-au-remove>Remove</button>
        </div>
      </div>`).join('') : '<p class="au-muted">Your bag is empty.</p><a class="au-link" href="'+escapeHTML(route('collections/all'))+'">Explore the collection</a>';
    const summary = select('[data-au-cart-summary]');
    if (summary) summary.hidden = !cart.items.length;
  }
  async function refreshCart() { const cart = await cartRequest('get');renderCart(cart);return cart; }
  async function changeQuantity(line, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0 || !line || line.dataset.loading) return;
    line.dataset.loading = 'true';
    all('button,input',line).forEach(el=>el.disabled=true);
    try { const cart=await cartRequest('change',{id:line.dataset.auLine,quantity});renderCart(cart); }
    catch(error){showCartError(error);all('button,input',line).forEach(el=>el.disabled=false);delete line.dataset.loading;}
  }
  function setupProduct(root) {
    if (root.dataset.auReady) return;
    root.dataset.auReady = 'true';
    const variants = JSON.parse(select('[data-au-variants]',root).textContent);
    const form = select('[data-au-product-form]',root);
    const idInput = select('[name="id"]',form);
    const button = select('[data-au-add]',root);
    const price = select('[data-au-price]',root);
    const compare = select('[data-au-compare]',root);
    const status = select('[data-au-product-status]',root);
    const media = select('[data-au-main-image]',root);
    const thumbnails = all('[data-au-thumbnail]',root);
    const optionGroups = all('[data-au-option]',root);
    const updateVariant = (changeImage, updateURL = true, clearStatus = true) => {
      const values = optionGroups.map(group => select('input:checked',group)?.value);
      const variant = optionGroups.length ? variants.find(v=>v.options.every((value,index)=>value===values[index])) : variants.find(v=>String(v.id)===String(idInput.value)) || variants[0];
      idInput.value=variant ? variant.id : '';
      idInput.disabled=!variant;
      button.disabled=!variant || !variant.available;
      button.textContent=!variant ? 'Unavailable combination' : variant.available ? 'Add to bag' : 'Sold out';
      if (variant) {
        price.textContent=money(variant.price);
        compare.hidden=!(variant.compare_at_price>variant.price);
        compare.textContent=variant.compare_at_price>variant.price ? money(variant.compare_at_price) : '';
        if (updateURL) {try{const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}catch{}}
        if (changeImage && variant.featured_image?.src && media) {
          media.src=newImage(root.dataset.auHandle,variant.featured_image.src);
          media.removeAttribute('srcset');
          media.alt=variant.featured_image.alt || root.dataset.auProductTitle;
          thumbnails.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.auSrc===media.getAttribute('src')||t.dataset.auImageId===String(variant.featured_image.id))));
        }
      }
      if (clearStatus) status.textContent='';
    };
    optionGroups.forEach(group=>group.addEventListener('change',()=>updateVariant(true)));
    const fallback = select('[data-au-variant-fallback]',root);
    if (fallback) {fallback.disabled=true;fallback.hidden=true;}
    all('[data-au-js-options]',root).forEach(el=>el.hidden=false);
    thumbnails.forEach(t=>t.addEventListener('click',()=>{
      const associated=variants.find(v=>newImage(root.dataset.auHandle,v.featured_image?.src)===t.dataset.auSrc);
      if(associated&&optionGroups.length){
        all('input',optionGroups[0]).forEach(input=>input.checked=input.value===associated.options[0]);
        updateVariant(true);
      }
      media.src=t.dataset.auSrc;media.removeAttribute('srcset');media.alt=t.dataset.auAlt || root.dataset.auProductTitle;
      thumbnails.forEach(b=>b.setAttribute('aria-pressed',String(b===t)));
    }));
    form.addEventListener('submit',async event=>{
      if (!idInput.value || button.disabled) {event.preventDefault();return;}
      event.preventDefault();button.disabled=true;button.textContent='Adding…';status.textContent='';
      try {
        await cartRequest('add',{id:idInput.value,quantity:Number(select('[name="quantity"]',form)?.value || 1)});
        await refreshCart();openDialog('aulbery-cart');
      } catch(error) {status.textContent=error.message;}
      finally {updateVariant(false,false,false);}
    });
    updateVariant(false,false);
    if(media)thumbnails.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.auSrc===media.getAttribute('src'))));
  }
  function setupGrid(root) {
    if (root.dataset.auReady) return;
    root.dataset.auReady='true';
    const cards=all('[data-au-category]',root), buttons=all('[data-au-filter]',root);
    function filter(value){
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.auFilter===value)));
      cards.forEach(c=>c.hidden=value!=='all'&&c.dataset.auCategory!==value);
      const empty=select('[data-au-empty]',root);if(empty)empty.hidden=cards.some(c=>!c.hidden);
    }
    buttons.forEach(b=>b.addEventListener('click',()=>filter(b.dataset.auFilter)));
    const requested=new URL(location.href).searchParams.get('category');
    filter(buttons.some(b=>b.dataset.auFilter===requested)?requested:'all');
  }
  function init(root = document) {all('[data-au-product]',root).forEach(setupProduct);all('[data-au-filter-grid]',root).forEach(setupGrid);}
  document.addEventListener('click',event=>{
    const opener=event.target.closest('[data-au-open]');
    if(opener){event.preventDefault();openDialog(opener.dataset.auOpen);return;}
    const close=event.target.closest('[data-au-close]');if(close){close.closest('dialog')?.close();return;}
    if(event.target instanceof HTMLDialogElement){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
    const qty=event.target.closest('[data-au-qty]');
    if(qty){const input=select('input',qty.closest('.au-qty'));input.value=Math.max(Number(input.min || 1),Number(input.value)+Number(qty.dataset.auQty));input.dispatchEvent(new Event('change',{bubbles:true}));}
    const line=event.target.closest('[data-au-line]');
    if(line){const remove=event.target.closest('[data-au-remove]'),step=event.target.closest('[data-au-cart-qty]');if(remove||step)changeQuantity(line,remove?0:Number(select('input',line).value)+Number(step.dataset.auCartQty));}
    const mobileLink=event.target.closest('.au-mobile-nav a');if(mobileLink)mobileLink.closest('dialog')?.close();
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-au-vip-enrollment]');
    if(!form)return;
    event.preventDefault();
    if(!form.reportValidity())return;
    const status=form.querySelector('[data-au-enrollment-status]');
    if(config.preview){status.textContent='Membership checkout connects to your billing provider after setup.';return;}
    try{const destination=new URL(form.dataset.auEnrollmentUrl,location.origin);if(destination.protocol!=='https:')throw new Error();location.assign(destination.href);}
    catch{status.textContent='Please contact support for help joining VIP Club.';}
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-au-cart-input]'))changeQuantity(event.target.closest('[data-au-line]'),Number(event.target.value));
    if(event.target.matches('[data-au-sort]')){const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);location.href=url;}
  });
  if(config.preview)document.addEventListener('submit',event=>{
    if(event.target.querySelector('[name="checkout"]')){event.preventDefault();showCartError(new Error('Checkout is available in your Shopify store after installing this theme.'));}
    if(event.target.classList.contains('au-preview-newsletter')){event.preventDefault();const status=document.createElement('p');status.className='au-status';status.textContent='Email signup connects to Shopify after installing the theme.';event.target.append(status);}
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();
